import BrandCoinCarousel from "./BrandCoinCarousel";

export default BrandCoinCarousel;
